/* eslint-disable react-hooks/refs */
import { getConfig } from '@qbe/qal';
import { sha256 } from 'js-sha256';
import { useRef } from 'react';

import { TargetEnv, targetEnv } from '~/config';

export const hashingHandler = (hashString: string) => sha256(hashString);

/**
 * Normalised Hash Address
 * @param email {string}
 * @returns {string}
 */
export const normaliseEmail = (email: string) =>
  hashingHandler(email.replace(/\s/gi, '').toLowerCase());

/**
 *
 * @param phone {string}
 * @returns {string}
 */
export const normalisePhone = (phone: string) =>
  hashingHandler(phone.replace(/\s|-/gi, '').toLowerCase());

export const getDaysPriorPayment = (date: string) => {
  // Date Format Checking - eg. 2024-03-10+11:00
  if (!/^\d\d\d\d-\d\d-\d\d\+\d\d:\d\d$/.test(date)) return '';
  const dueDate = new Date(date.split('+')[0]);
  const todayDate = new Date();
  const dd = String(todayDate.getDate()).padStart(2, '0');
  const mm = String(todayDate.getMonth() + 1).padStart(2, '0');
  const yyyy = todayDate.getFullYear();
  const today = new Date(`${yyyy}-${mm}-${dd}`);

  const differenceTime = dueDate.getTime() - today.getTime();
  const differenceDay = differenceTime / (1000 * 3600 * 24);
  return differenceDay;
};

export const useIsFirstRender = (): boolean => {
  const isFirst = useRef(true);

  if (isFirst.current) {
    if (targetEnv !== TargetEnv.prod) console.log('First render');
    isFirst.current = false;
    return true;
  }

  return isFirst.current;
};

export const getActivePagePath = () => {
  const { basePagePath = '' } = getConfig();
  const activatePagePath = getConfig().analyticsDataObject?.activePagePath ?? '';
  return `${basePagePath}${activatePagePath}`;
};
